/**
 * ╔══════════════════════════════════════════════════════════════════╗
 * ║                   MADAR.IQ - PROTECTED CODE                      ║
 * ║  © 2026 Madar.iq — All Rights Reserved.                          ║
 * ║  This software is proprietary and confidential.                  ║
 * ║  Unauthorized copying, modification, distribution, or use        ║
 * ║  of this software, in whole or in part, is strictly prohibited   ║
 * ║  and constitutes a violation of applicable intellectual property  ║
 * ║  laws. Legal action will be taken against violators.             ║
 * ╚══════════════════════════════════════════════════════════════════╝
 */

(function () {
  "use strict";

  // ── 1. لا تفعّل الحماية في بيئة التطوير ──────────────────────────
  const isDev =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    process.env.NODE_ENV === "development";

  if (isDev) return;

  // ── 2. منع Right-Click ────────────────────────────────────────────
  document.addEventListener("contextmenu", function (e) {
    e.preventDefault();
    return false;
  });

  // ── 3. منع اختصارات لوحة المفاتيح الخطرة ─────────────────────────
  document.addEventListener("keydown", function (e) {
    // F12
    if (e.key === "F12") {
      e.preventDefault();
      return false;
    }
    // Ctrl+Shift+I / Ctrl+Shift+J / Ctrl+Shift+C / Ctrl+U
    if (
      e.ctrlKey &&
      e.shiftKey &&
      (e.key === "I" || e.key === "i" || e.key === "J" || e.key === "j" || e.key === "C" || e.key === "c")
    ) {
      e.preventDefault();
      return false;
    }
    // Ctrl+U (view source)
    if (e.ctrlKey && (e.key === "U" || e.key === "u")) {
      e.preventDefault();
      return false;
    }
    // Ctrl+S (save)
    if (e.ctrlKey && (e.key === "S" || e.key === "s")) {
      e.preventDefault();
      return false;
    }
    // Ctrl+A (select all)
    if (e.ctrlKey && (e.key === "A" || e.key === "a")) {
      e.preventDefault();
      return false;
    }
  });

  // ── 4. منع النسخ والتحديد ─────────────────────────────────────────
  document.addEventListener("copy", function (e) {
    e.preventDefault();
    return false;
  });

  document.addEventListener("selectstart", function (e) {
    e.preventDefault();
    return false;
  });

  document.addEventListener("dragstart", function (e) {
    e.preventDefault();
    return false;
  });

  // ── 5. كشف DevTools عبر قياس الحجم ───────────────────────────────
  const _devToolsCheck = {
    isOpen: false,
    orientation: undefined,
  };

  const _threshold = 160;

  function _detectDevTools() {
    const widthDiff = window.outerWidth - window.innerWidth > _threshold;
    const heightDiff = window.outerHeight - window.innerHeight > _threshold;

    if (widthDiff || heightDiff) {
      if (!_devToolsCheck.isOpen) {
        _devToolsCheck.isOpen = true;
        _onDevToolsOpen();
      }
    } else {
      _devToolsCheck.isOpen = false;
    }
  }

  function _onDevToolsOpen() {
    // إعادة توجيه إلى صفحة 403 عند فتح DevTools
    document.body.innerHTML = `
      <div style="
        display:flex;
        flex-direction:column;
        align-items:center;
        justify-content:center;
        height:100vh;
        background:#0f172a;
        color:#f8fafc;
        font-family:sans-serif;
        text-align:center;
        gap:16px;
      ">
        <div style="font-size:64px;">🔒</div>
        <h1 style="font-size:2rem;font-weight:700;color:#ef4444;">Access Denied</h1>
        <p style="color:#94a3b8;max-width:400px;">
          هذا البرنامج محمي بموجب قوانين الملكية الفكرية.<br/>
          <strong style="color:#f1f5f9;">© 2026 Madar.iq — All Rights Reserved</strong>
        </p>
      </div>
    `;
  }

  setInterval(_detectDevTools, 1000);

  // ── 6. منع Console في الإنتاج ─────────────────────────────────────
  const _noop = function () { };
  const _warn = console.warn.bind(console);

  // رسالة تحذيرية في Console
  const _protectionMsg = [
    "%c⚠ STOP! هذا التطبيق محمي",
    "color:#ef4444;font-size:24px;font-weight:bold;",
  ];

  const _infoMsg = [
    "%c© 2026 Madar.iq — جميع الحقوق محفوظة\nهذا الكود ملكية خاصة. أي محاولة لسرقة أو نسخ أو تعديل هذا الكود تعرضك للمساءلة القانونية.",
    "color:#f59e0b;font-size:13px;",
  ];

  // استبدال console بعد إظهار التحذير
  setTimeout(function () {
    if (typeof console !== "undefined") {
      try {
        console.log(..._protectionMsg);
        console.log(..._infoMsg);
        
        const _origErr = console.error;
        console.log = _noop;
        console.warn = _noop;
        console.info = _noop;
        console.debug = _noop;
        console.dir = _noop;
        console.table = _noop;
        
        // إبقاء error متاحاً فقط للأخطاء الحقيقية من النظام
        console.error = function(...args) {
          if (args[0] && typeof args[0] === 'string' && args[0].includes('[Madar.iq]')) {
             _origErr.apply(console, args);
          }
        };
      } catch (e) {
        // ignore
      }
    }
  }, 500);

  // ── 7. الحماية من Debugger ────────────────────────────────────────
  // تشغيل debugger بشكل متكرر لإبطاء محاولات التحليل
  setInterval(function () {
    (function () {
      return false;
    }
      .constructor("debugger")
      .call());
  }, 10000);

  // ── 8. تشفير رسالة في localStorage ───────────────────────────────
  try {
    const _stamp = btoa(
      JSON.stringify({
        product: "Madar.iq",
        license: "PROPRIETARY",
        year: 2026,
        warning: "Unauthorized use prohibited",
      })
    );
    localStorage.setItem("_madar_protected", _stamp);
  } catch (e) {
    // ignore
  }

  // ── 9. حماية من iFrame (Clickjacking) ────────────────────────────
  if (window.self !== window.top) {
    window.top.location = window.self.location;
  }
})();
